module.exports = __webpack_public_path__ + "static/media/2.12_preview.b82fbb8f.png";